import { Component } from 'react'
import style from './style.less'
import { Skeleton } from 'antd-mobile-v5'
interface IState {}
interface IProps {
  visible: boolean
  demo: string
}
class Loading extends Component<IProps, IState> {
  public static defaultProps = {
    visible: false,
    demo: 'loading...'
  }

  public render () {
    return (
      <div className={style.box}>
        <Skeleton.Title animated />
        <Skeleton.Paragraph lineCount={18} animated />
      </div>
    )
  }
}
export default Loading
